import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { AutoResizeDirective } from './utils/auto-resize.directive';
import { EditorSidebarComponent } from './editor-sidebar/editor-sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { CreateCaseComponent } from './create-case/create-case.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { EditorSwitcherComponent } from '@shared/components/editor-switcher/editor-switcher.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CaseRequestPipe } from '@shared/pipes';
import { NgxEditorModule } from 'ngx-editor';
import { AngularSplitModule } from 'angular-split';
import { HeaderComponent } from '@shared/components/header/header.component';
import { MarkdownModule } from 'ngx-markdown';
import { FeedbackButtonComponent } from '@shared/components/feedback-button/feedback-button.component';
import { ThemeToggleComponent } from '@shared/components/theme-toggle/theme-toggle.component';

@NgModule({
  declarations: [
    AppComponent,
    EditorSidebarComponent,
    LoadingOverlayComponent,
    CreateCaseComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,

    PdfViewerModule,
    ModalModule.forRoot(),
    NgxSpinnerComponent,
    ToastrModule.forRoot(),
    PopoverModule,
    EditorSwitcherComponent,
    BsDropdownModule.forRoot(),
    CaseRequestPipe,
    AngularSplitModule,
    NgxEditorModule,
    AutoResizeDirective,
    HeaderComponent,
    MarkdownModule.forRoot(),
    FeedbackButtonComponent,
    ThemeToggleComponent
  ],
  providers: [
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
